import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";
import { Clipboard } from "@capacitor/clipboard";

export const isNative = () => Capacitor.isNativePlatform();
export const isIOS = () => Capacitor.getPlatform() === "ios" || (/iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream);
export const isStandalone = () => isNative() || window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

/** Opens an external URL: in-app SFSafariViewController on iOS native, new tab elsewhere. Returns false if blocked. */
export async function openExternal(url) {
  if (isNative()) { await Browser.open({ url, presentationStyle: "popover" }); return true; }
  const win = window.open(url, "_blank");
  if (win) { win.opener = null; return true; }
  return false;
}

export async function copyText(text) {
  if (isNative()) { await Clipboard.write({ string: text }); return true; }
  try { await navigator.clipboard.writeText(text); return true; }
  catch { return false; }
}

/** Native-only boot: status bar + splash. No-op on web. */
export async function initNative() {
  if (!isNative()) return;
  document.documentElement.classList.add("is-native", `platform-${Capacitor.getPlatform()}`);
  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    await StatusBar.setStyle({ style: Style.Dark });
  } catch { /* plugin missing */ }
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide();
  } catch { /* plugin missing */ }
  try {
    const { App } = await import("@capacitor/app");
    App.addListener("appUrlOpen", ({ url }) => { try { const u = new URL(url); window.location.assign(u.pathname + u.search); } catch { /* ignore */ } });
  } catch { /* plugin missing */ }
}
